import styled from 'styled-components';

// min-width:0 lets this grid item shrink to its column instead of widening the form on a long value
export const Container = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
  padding: 3px 0;
`;

export const SpinnerContainer = styled.div`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => theme.spacing(2)};
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
  color: ${({ theme }) => theme.palette.grey[400]};
`;
